<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.specialWorkday.searchText')"
                        solo
                        height="40px"
                        @keyup.enter="searchSpecialWorkdays()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        height="40px"
                        color="primary"
                        outlined
                        @click="searchSpecialWorkdays()">
                        {{ $vuetify.lang.t('$vuetify.specialWorkday.search') }}
                    </v-btn>
                </div>
            </div>
            <div>
                <v-btn
                    v-if="canUpdate"
                    height="40px"
                    @click="addSpecialWorkday()"
                    color="primary">
                    + {{ $vuetify.lang.t('$vuetify.specialWorkday.addSpecialWorkday') }}
                </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalSpecialWorkday"
                :items="specialWorkdays"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action" v-if="canUpdate">
                        <div :class="actionStyle(item)">
                            <i class="mr-4 far fa-edit" @click="editSpecialWorkday(item)"></i>
                            <i class="mr-3 far fa-trash-alt" @click="deleteSpecialWorkday(item)"></i>
                        </div>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <special-workday-form-modal
            v-if="specialWorkdayFormModalShow"
            ref="specialWorkdayFormModal"
            @close="specialWorkdayFormModalShow = false"
            @success="searchSpecialWorkdays()"
            :mode="mode"
            :specialWorkdayId="specialWorkdayId"/>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deletedSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal.vue'
import SpecialWorkdayFormModal from '@/components/TimeTableSetting/SpecialWorkdayFormModal'

export default {
    name: 'SpecialWorkDay',

    components: {
        SpecialWorkdayFormModal,
        DeleteModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalSpecialWorkday: 0,
            specialWorkdays: [],
            mode: '',
            specialWorkdayFormModalShow: false,
            specialWorkdayId: null,
            deleteForm: {
                header: '',
                content: '',
                path: ''
            },
            canUpdate: false
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.specialWorkdayName'), value: 'name', width: '25%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.createdDate'), value: 'created_at', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.workDate'), value: 'date', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.startEndTime'), value: 'startEndTime', width: '17%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.bureau'), value: 'bureau', width: '24%' },
                { text: this.$vuetify.lang.t('$vuetify.specialWorkday.action'), value: 'action', width: '8%', sortable: false }
            ]
        }
    },

    methods: {
        async searchSpecialWorkdays () {
            this.options.page = 1
            await this.getSpecialWorkdays()
        },

        async getSpecialWorkdays () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `special-workdays?page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.specialWorkdays = res.data.data
                this.totalSpecialWorkday = res.data.total
                this.loading = false
            }
        },

        addSpecialWorkday () {
            this.mode = 'create'
            this.specialWorkdayFormModalShow = true
        },

        editSpecialWorkday (item) {
            this.specialWorkdayId = item.id
            this.mode = 'update'
            this.specialWorkdayFormModalShow = true
        },

        deleteSpecialWorkday (item) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.specialWorkday.deleteHeader')
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.specialWorkday.wantToDelete')} "${item.name}"? `
            this.deleteForm.path = `special-workday/delete/${item.id}`
            this.$refs.modalDelete.dialog = true
        },

        async deletedSuccess () {
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.specialWorkday.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.specialWorkday.deletedSpecialWorkday'),
                type: 'success'
            })
            await this.searchSpecialWorkdays()
        },

        actionStyle (item) {
            const workDate = this.$dateUtil.dateBEStringToDateObj(item.date)
            return new Date() > workDate ? 'action-disable' : 'action-enable'
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.TIMETABLE_SETTING.UPDATE)
    },

    watch: {
        options: {
            async handler () {
                await this.getSpecialWorkdays()
            },
            deep: true
        },

        '$vuetify.lang.current': {
            handler: async function () {
                await this.getSpecialWorkdays()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;
        width: 340px;
    }
}

.action {
    display: flex;
    align-items: center;

    .action-enable i {
        cursor: pointer;
    }

    .action-disable i {
        pointer-events: none;
        cursor: not-allowed;
        color: #a8a8a8 !important;
    }

    i {
        color: #6c6c6c;
    }
}
</style>
